import { useSearchParams } from 'react-router';
import { type ChosenPeriod, periodOfSearch, withPeriod } from './chosen-period.js';

type ChosenPeriodState = {
  chosen: ChosenPeriod;
  choose: (period: ChosenPeriod) => void;
};

export const useChosenPeriod = (): ChosenPeriodState => {
  const [searchParams, setSearchParams] = useSearchParams();

  const choose = (period: ChosenPeriod): void => {
    setSearchParams((current) => withPeriod(current, period), { replace: true });
  };

  return { chosen: periodOfSearch(searchParams), choose };
};
